export enum EstadosTipoEnum { REQUESTED, IN_PROCESS, DELIVERED, REFUNDED, ERROR, RECOVERING, AUTHORIZED }

const idsEstadosTipo = new Map<EstadosTipoEnum, string>();
idsEstadosTipo.set(EstadosTipoEnum.REQUESTED, "REQUESTED");
idsEstadosTipo.set(EstadosTipoEnum.IN_PROCESS, "IN_PROCESS");
idsEstadosTipo.set(EstadosTipoEnum.DELIVERED, "DELIVERED");
idsEstadosTipo.set(EstadosTipoEnum.REFUNDED, "REFUNDED");
idsEstadosTipo.set(EstadosTipoEnum.ERROR, "ERROR");
idsEstadosTipo.set(EstadosTipoEnum.RECOVERING, "RECOVERING");
idsEstadosTipo.set(EstadosTipoEnum.AUTHORIZED, "AUTHORIZED");

const nombresEstadosTipo = new Map<EstadosTipoEnum, string>();
nombresEstadosTipo.set(EstadosTipoEnum.REQUESTED, "Solicitado");
nombresEstadosTipo.set(EstadosTipoEnum.IN_PROCESS, "En progreso");
nombresEstadosTipo.set(EstadosTipoEnum.DELIVERED, "Entregado");
nombresEstadosTipo.set(EstadosTipoEnum.REFUNDED, "Devuelto");
nombresEstadosTipo.set(EstadosTipoEnum.ERROR, "ERROR");
nombresEstadosTipo.set(EstadosTipoEnum.RECOVERING, "Recuperando");
nombresEstadosTipo.set(EstadosTipoEnum.AUTHORIZED, "Autorizado");

export const obtenerNombreEstadosTipo: (estado: EstadosTipoEnum) => string = estado =>
    nombresEstadosTipo.get(estado) ?? "";
